import { render, staticRenderFns } from "./PromotionRatePlanMappingForm.vue?vue&type=template&id=91a3486a&scoped=true&"
import script from "./PromotionRatePlanMappingForm.vue?vue&type=script&lang=js&"
export * from "./PromotionRatePlanMappingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a3486a",
  null
  
)

export default component.exports